import{K_COLOR_VALUE_BY_NAME as o}from"../Colors/index.js";import r from"../Typography/index.js";const t=(t,i="b3",n="neutral900")=>{let e=i,p=n;if(t){const o=t.split("-");[e,p]=o}return e in r||(e=i),p in o||(p=n),[r[e],{color:o[p]}]};export{t as getStyleTheme};
//# sourceMappingURL=utils.js.map
